import {
  FETCH_CURRENT_PAGE,
  CHANGE_CURRENT_PAGE,
  EMPTY_CURRENT_PAGE,
  NAVBAR_SET_BUTTON,
  REGENERATOR,
} from '../actions/currentPageAction';

const initialState = {};
const currentPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CURRENT_PAGE: {
      const { type, payload } = action.payload;
      return {
        ...state,
        [type]: payload,
      };
    }
    case CHANGE_CURRENT_PAGE: {
      const { key, currentPage } = action.payload;
      return {
        ...state,
        [key]: currentPage,
      };
    }
    case EMPTY_CURRENT_PAGE: {
      return {};
    }
    case REGENERATOR: {
      const { page } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          regenerator: Math.random(),
        },
      };
    }
    case NAVBAR_SET_BUTTON: {
      const { page, key, value } = action.payload;
      return {
        ...state,
        [page]: {
          ...state[page],
          navBar: {

            ...state[page].navBar,
            [key]: value,
          },

        },
      };
    }
    default:
      return state;
  }
};
export default currentPageReducer;
